"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const Left1DChart_1 = __importDefault(require("../1d-tracer/Left1DChart"));
const Top1DChart_1 = __importDefault(require("../1d-tracer/Top1DChart"));
const Contours_1 = __importDefault(require("./Contours"));
function FTContainer(props) {
    const { spectra } = props;
    const activeSpectrum = (0, useSpectrum_1.default)();
    if (activeSpectrum?.info?.isFid) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [spectra?.[0] && (0, jsx_runtime_1.jsx)(Top1DChart_1.default, { data: spectra[0] }), spectra?.[1] && (0, jsx_runtime_1.jsx)(Left1DChart_1.default, { data: spectra[1] }), (0, jsx_runtime_1.jsx)(Contours_1.default, {})] }));
}
exports.FTContainer = FTContainer;
